import React from 'react';

export const InBrowser: React.FC = ({ children }) => (__IS_SERVER__ ? null : <>{children}</>);
export const AtServer: React.FC = ({ children }) => (__IS_SERVER__ ? <>{children}</> : null);
